import React from "react";
import DeviceMapManager from "../../components/attendance/DeviceMapManager";

export default function StudentDeviceMapPage() {
  return <DeviceMapManager subjectType="STUDENT" title="Student Device ID Mapping" personLabel="Student" />;
}
